import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "flow-container" }
const _hoisted_2 = { class: "path-list-container" }
const _hoisted_3 = { class: "sub-heading sub-heading-left" }
const _hoisted_4 = { class: "title is-6" }
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = { class: "menu-list" }
const _hoisted_7 = { class: "path-item" }
const _hoisted_8 = { class: "path-link" }
const _hoisted_9 = {
  key: 0,
  class: "invalid-warning"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "icon draggable-icon" }
const _hoisted_12 = { class: "path-link" }
const _hoisted_13 = {
  key: 0,
  class: "invalid-warning"
}

import Draggable from 'vuedraggable';
import { nanoid } from 'nanoid';
import { PathViewModel } from '@/features/bots/models/designer';
import PathDesigner from '../components/designer/PathDesigner.vue';
import { SET_PATHS, ADD_PATH, SET_CURRENT_PATH } from '@/store/bot-designer/paths/mutationTypes';
import DragIcon from '@/shared/components/DragIcon.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import { LOAD_HOLIDAYS } from '@/store/holidays/actionTypes';
import { HolidayViewModel } from '@/features/bots/models/holidayViewModel';
import { useStore } from 'vuex';
import { computed, onBeforeMount } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FlowEditor',
  setup(__props) {

const store = useStore();
const paths = computed(() => store.getters.paths);
const currentPathId = computed(() => store.getters.currentPathId);
const firstPath = computed(() => store.getters.firstPath);
const isPathInvalid = computed(() => store.getters.isPathInvalid);

const setPaths = (paths: PathViewModel[]) => store.commit(SET_PATHS, paths);
const addPath = (path: PathViewModel) => store.commit(ADD_PATH, path);
const setCurrentPath = (id: string) => store.commit(SET_CURRENT_PATH, id);

const loadHolidays = (forceReload = false): Promise<HolidayViewModel[]> => store.dispatch(LOAD_HOLIDAYS, forceReload);

onBeforeMount(() => loadHolidays());

const reorderablePathList = computed({
  get() {
    return paths.value.slice(1);
  },
  set(value) {
    value.unshift(firstPath.value);
    setPaths(value);
  },
});

function addNewPath() {
  const newPath = {
    id: `path-${nanoid(7)}`,
    name: `New Path`,
    states: [],
  } as PathViewModel;

  addPath(newPath);
  setCurrentPath(newPath.id);
}

function isPathActive(pathId: string): boolean {
  return currentPathId.value === pathId;
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, [
          _cache[3] || (_cache[3] = _createTextVNode(" Paths ", -1)),
          _createVNode(_component_n_tooltip, {
            position: "right",
            text: "Paths are used to create sections of a flow. A path ends when there are no more states to process. The flow can continue by transitioning to other paths"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewPath())),
                class: "add-button"
              }, [
                _createVNode(AddIcon, {
                  title: "",
                  class: "icon-1-3x"
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("aside", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", {
            class: _normalizeClass(["first-path path-list-item", { 'is-active': isPathActive(firstPath.value.id) }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setCurrentPath(firstPath.value.id)))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_n_tooltip, {
                position: "top",
                text: "The first path cannot be moved or deleted"
              }),
              _createElementVNode("a", _hoisted_8, _toDisplayString(firstPath.value.name), 1),
              (isPathInvalid.value(firstPath.value.id))
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createVNode(ErrorIcon, { class: "icon-1-3x" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          _createVNode(_unref(Draggable), {
            modelValue: reorderablePathList.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((reorderablePathList).value = $event)),
            "item-key": "id"
          }, {
            item: _withCtx(({ element: path }) => [
              (_openBlock(), _createElementBlock("li", {
                class: "path-list-item",
                key: path.id,
                onClick: ($event: any) => (setCurrentPath(path.id))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["draggable path-item", { 'is-active': isPathActive(path.id) }])
                }, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(DragIcon, {
                      color: "#A9A9A9",
                      class: "icon-1-5x"
                    })
                  ]),
                  _createElementVNode("a", _hoisted_12, _toDisplayString(path.name), 1),
                  (isPathInvalid.value(path.id))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        _createVNode(ErrorIcon, { class: "icon-1-3x" })
                      ]))
                    : _createCommentVNode("", true)
                ], 2)
              ], 8, _hoisted_10))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode(PathDesigner)
  ]))
}
}

})